<!-- Hızlı Parametre Ekleme Paneli -->
<div class="hizli-ekle-konteyner">

  <!-- Sık Kullanılan Türler + Diğer -->
  <div class="tur-bar">
    @for (tur of sikKullanilanTurler; track tur.turu) {
      <button nz-button
              nzSize="small"
              [nzType]="secilenTur?.turu === tur.turu ? 'primary' : 'default'"
              (click)="turSec(tur)"
              nz-tooltip
              [nzTooltipTitle]="tur.aciklama || tur.etiket">
        <nz-icon [nzType]="tur.simge" />
        <span class="tur-etiket">{{ tur.etiket }}</span>
      </button>
    }

    <!-- Tüm Türler Dropdown -->
    <button nz-button
            nzSize="small"
            nz-dropdown
            [nzDropdownMenu]="tumTurlerMenu"
            nzTrigger="click"
            [(nzVisible)]="tumTurlerAcik">
      <nz-icon nzType="appstore" />
      <span class="tur-etiket">Diğer</span>
      <nz-icon nzType="down" />
    </button>

    <!-- Hazır Setler gizlendi -->
  </div>

  <!-- İsim Giriş Paneli (tür seçilince açılır) -->
  @if (panelAcik && secilenTur) {
    <div class="isim-panel" (keydown)="escIleKapat($event)">
      <nz-tag [nzColor]="'blue'">
        <nz-icon [nzType]="secilenTur.simge" />
        {{ secilenTur.etiket }}
      </nz-tag>
      <nz-input-wrapper nzSize="small" [nzSuffix]="ekleButonRef" class="isim-input-grup">
        <input nz-input
               class="hizli-ekle-isim-input"
               placeholder="Parametre adı yazın, Enter ile ekleyin"
               [(ngModel)]="parametreIsmi"
               (keydown.enter)="enterIleEkle()"
               nzSize="small" />
      </nz-input-wrapper>
      <ng-template #ekleButonRef>
        <nz-icon nzType="check"
                 class="ekle-ikon"
                 [class.aktif]="parametreIsmi?.trim()"
                 (click)="enterIleEkle()"
                 nz-tooltip
                 nzTooltipTitle="Ekle (Enter)" />
      </ng-template>
      <button nz-button
              nzSize="small"
              nzType="text"
              nzShape="circle"
              (click)="paneliKapat()"
              nz-tooltip
              nzTooltipTitle="Kapat (Esc)">
        <nz-icon nzType="close" />
      </button>
    </div>
  }
</div>

<!-- Hazır Setler Dropdown Menüsü -->
<nz-dropdown-menu #hazirSetlerMenu="nzDropdownMenu">
  <div nz-menu class="hazir-setler-liste">
    @for (set of hazirSetler; track set.ismi) {
      <div nz-menu-item (click)="hazirSetEkle(set)" class="hazir-set-item">
        <nz-icon [nzType]="set.simge" class="set-simge" />
        <div class="set-bilgi">
          <span class="set-ismi">{{ set.ismi }}</span>
          <span class="set-aciklama">{{ set.aciklama }} ({{ set.parametreler.length }} alan)</span>
        </div>
      </div>
    }
  </div>
</nz-dropdown-menu>

<!-- Tüm Türler Dropdown Menüsü -->
<nz-dropdown-menu #tumTurlerMenu="nzDropdownMenu">
  <div class="tum-turler-grid" nz-menu>
    @for (tur of tumTurler; track tur.turu) {
      <div class="tur-hucre"
           nz-menu-item
           (click)="tumTurlerdenSec(tur)"
           nz-tooltip
           [nzTooltipTitle]="tur.aciklama">
        <nz-icon [nzType]="tur.simge" class="tur-simge" />
        <span class="tur-isim">{{ tur.etiket }}</span>
      </div>
    }
  </div>
</nz-dropdown-menu>
